import { useState, useContext, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'

import { AppContext } from "/providers/app-context"
import logo from '/assets/images/smartix-logo.png'
import { logout } from '/providers/auth-api'

export default function ButtonAppBar({ title, toggleHelp, toggleSettings, isErrorPage }) {

  const [anchorEl, setAnchorEl] = useState(null)
  const { client } = useContext(AppContext)

  const menuOpen = Boolean(anchorEl)
  const handleClick = e => setAnchorEl(e.currentTarget)
  const handleClose = () => setAnchorEl(null)

  useEffect(() => {
    document.title = "Smartix: " + title
  }, [title])


  return (
    <Box >
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 , bgcolor:"menubar.bg", color:"menubar.fg"}}>
        <Toolbar>
          {!isErrorPage &&
            <>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={handleClick}
                disabled={client === null}
              >
                <MenuIcon />
              </IconButton>

              <Menu
                id="basic-menu"
                open={menuOpen}
                onClose={handleClose}
                anchorEl={anchorEl}
              >
                <MenuItems handleClose={handleClose} />
              </Menu>
            </>}

          <img src={logo} style={{ height: 50, marginRight: 10 }} />

          <Typography variant="h6" component="div" sx={{ flexGrow: 1, flexShrink: 0, whitespace: "nowrap" }}>
            <span className='smartix'>SMARTIX</span> <span className='studio'>Studio</span> : {title ?? ""}
          </Typography>

          <IconButton onClick={toggleSettings} color='inherit'><SettingsOutlinedIcon /></IconButton>
          <IconButton onClick={toggleHelp} color='inherit'><HelpOutlineIcon /></IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

const StyledNavLink = ({ handleClose, url, label }) => <NavLink to={url} className="nav-link" onClick={handleClose}>{label}</NavLink>


const MenuItems = ({ handleClose }) => {

  const navigate = useNavigate()

  const { apiSource, user, client, setClient, setUser } = useContext(AppContext)

  const logoutUser = async () => {
    await logout({ apiSource })

    setUser(null)
    setClient(null)
    handleClose()
    navigate("/login")
  }

  const menuItems = []

  if (client?.initialised) {
    menuItems.push(<MenuItem key="home" onClick={() => { navigate("/"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/" label="Home" /></MenuItem>)
    menuItems.push(<MenuItem key="templates" onClick={() => { navigate("/templates"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/templates" label="Pass Templates" /></MenuItem>)
    menuItems.push(<MenuItem key="create-template" onClick={() => { navigate("/create-template"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/create-templates" label="Create Template" /></MenuItem>)
    menuItems.push(<MenuItem key="active-passes" onClick={() => { navigate("/active-passes"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/active-passes" label="Active Passes" /></MenuItem>)

    menuItems.push(<MenuItem key="dashboard" onClick={() => { navigate("/download-apps"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/download-apps" label="Download Scan App" /></MenuItem>)

    if (user?.permissions.client_admin) {
      menuItems.push(<MenuItem key="statistics" onClick={() => { navigate("/statistics"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/statistics" label="Statistics" /></MenuItem>)
      menuItems.push(<MenuItem key="account-management" onClick={() => { navigate("/account-management"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/account-management" label="Account Management" /></MenuItem>)
      menuItems.push(<MenuItem key="billing" onClick={() => { navigate("/billing/invoices"); handleClose() }} className='link'><StyledNavLink handleClose={handleClose} url="/billing/invoices" label="Billing" /></MenuItem>)
    }

    menuItems.push(<MenuItem key="preferences" className="link" onClick={() => { toggleSettings(); handleClose() }}>Preferences</MenuItem>)
  }

  menuItems.push(<MenuItem key="support" onClick={() => { navigate("/support"); handleClose() }} className='link' ><StyledNavLink handleClose={handleClose} url="/support" label="Request Support" /></MenuItem>)
  menuItems.push(<MenuItem key="logout" onClick={logoutUser} className='link logout'>Logout</MenuItem>)

  return menuItems
}